import {dynamic} from '@github-ui/dynamic'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'
import type {IssuesRouteComponents} from './create-issues-routes'

export const lazyIssuesRouteComponents: IssuesRouteComponents = {
  IssueNewChoose: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.IssueNewChoose}
    }),
  ),
  IssueViewer: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./IssueViewer')
      return {default: module.IssueViewer}
    }),
  ),
  IssuesIndexContent: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.IssuesIndexContent}
    }),
  ),
  IssuesLayout: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.IssuesLayout}
    }),
  ),
  IssueNew: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.IssueNew}
    }),
  ),
  Labels: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.Labels}
    }),
  ),
  MilestoneEdit: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.MilestoneEdit}
    }),
  ),
  MilestoneNew: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.MilestoneNew}
    }),
  ),
  MilestoneIndex: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.MilestoneIndex}
    }),
  ),
  MilestoneShow: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.MilestoneShow}
    }),
  ),
  RepositoryProjectsPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.RepositoryProjectsPage}
    }),
  ),
  SavedView: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.SavedView}
    }),
  ),
  SavedViewNew: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.SavedViewNew}
    }),
  ),
  SavedViews: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.SavedViews}
    }),
  ),
}
